import React from "react";


import rotatesfx0 from "assets/sfx/ret0.mp3";
import rotatesfx1 from "assets/sfx/ret1.mp3";
import rotatesfx2 from "assets/sfx/ret2.mp3";
import rotatesfx3 from "assets/sfx/ret3.mp3";
import rotatesfx4 from "assets/sfx/ret4.mp3";
import rotatesfx5 from "assets/sfx/ret5.mp3";
import rotatesfx6 from "assets/sfx/ret6.mp3";
import rotatesfx7 from "assets/sfx/ret7.mp3";
import rotatesfx8 from "assets/sfx/ret8.mp3";
import rotatesfx9 from "assets/sfx/ret9.mp3";
const rotateSFXs = [
  rotatesfx0,
  rotatesfx1,
  rotatesfx2,
  rotatesfx3,
  rotatesfx4,
  rotatesfx5,
  rotatesfx6,
  rotatesfx7,
  rotatesfx8,
  rotatesfx9,
];

export const DialpadContext = React.createContext();

class DialpadRenderer extends React.Component {
  canvasRef;
  canvasSize = 0;
  discFillColor = "";
  discStrokeColor = "";
  circlesFillColor = "";
  circlesStrokeColor = "";
  circlesHighlightColor = "";
  textFillColor = "";
  textStrokeColor = "";
  callback = () => {};

  constructor(props) {
    super(props);

    this.canvasRef = React.createRef();
    this.state = {
      a: 1,
      initialNumber: null,
      initialPosition: null,
      clicking: false,
      number: null,
      newAngle: 0,
      lastAngle: 0,
      returnSpeed: 0,
      canvasSize: props.canvasSize,
    };
    this.discFillColor = props.discFillColor || "transparent";
    this.discStrokeColor = props.discStrokeColor || "black";
    this.circlesFillColor = props.circlesFillColor || "black";
    this.circlesStrokeColor = props.circlesStrokeColor || "transparent";
    this.circlesHighlightColor = props.circlesHighlightColor || "red";
    this.circlesHighlightFillColor = props.circlesHighlightFillColor || "#00ff00";
    this.circlesHighlightStrokeColor =
      props.circlesHighlightStrokeColor || "transparent";
    this.circlesHighlightTextColor = props.circlesHighlightTextColor || "white";
    this.textFillColor = props.textFillColor || "white";
    this.textStrokeColor = props.textStrokeColor || "transparent";
    this.arrowFillColor = props.arrowFillColor || "black";
    this.arrowStrokeColor = props.arrowStrokeColor || "transparent";

    this.callback = props.callback || console.log;
  }

  componentDidMount() {
    this.size = this.state.canvasSize - 2;
    this.canvas = this.canvasRef.current;
    this.canvas.width = this.w = this.state.canvasSize;
    this.canvas.height = this.h = this.state.canvasSize;
    this.w2 = this.w / 2;
    this.h2 = this.h / 2;
    this.TWOPI = Math.PI * 2;
    this.offset = this.size * 0.25;
    this.outerCircle = this.size / 2;
    this.innerCircle = this.outerCircle - this.offset;

    this.c = this.canvas.getContext("2d");
    this.c.font = this.size * 0.08 + "px Arial";
    this.c.textAlign = "center";

    this.draw();
    this.addEvent();
  }
  componentDidUpdate() {
    this.size = this.state.canvasSize - 2;
    this.canvas = this.canvasRef.current;
    this.canvas.width = this.w = this.state.canvasSize;
    this.canvas.height = this.h = this.state.canvasSize;
    this.w2 = this.w / 2;
    this.h2 = this.h / 2;
    this.TWOPI = Math.PI * 2;
    this.offset = this.size * 0.25;
    this.outerCircle = this.size / 2;
    this.innerCircle = this.outerCircle - this.offset;

    this.c = this.canvas.getContext("2d");
    this.c.font = this.size * 0.08 + "px Arial";
    this.c.textAlign = "center";
    this.draw();
  }
  componentWillReceiveProps(nextProps) {
    this.circlesHighlightFillColor =
      nextProps.circlesHighlightFillColor || this.circlesHighlightFillColor;
    this.circlesHighlightStrokeColor =
      nextProps.circlesHighlightStrokeColor || this.circlesHighlightStrokeColor;
    this.circlesHighlightTextColor =
      nextProps.circlesHighlightTextColor || this.circlesHighlightTextColor;
    this.setState({ canvasSize: nextProps.canvasSize });
  }

  draw() {
    this.c.clearRect(0, 0, this.w, this.h);
    this.c.beginPath();
    this.c.arc(this.w2, this.h2, this.outerCircle, 0, this.TWOPI, false);
    this.c.moveTo(this.w2 + this.innerCircle, this.h2);
    this.c.arc(this.w2, this.h2, this.innerCircle, this.TWOPI, 0, true);
    this.c.fillStyle = this.discFillColor;
    this.c.fill();
    this.c.strokeStyle = this.discStrokeColor;
    this.c.stroke();
    this.c.save();
    this.c.translate(this.w2, this.h2);
    for (let i = 0; i < 10; i++) {
      const a = this.state.a + i / 2;

      const center =
        this.innerCircle + ((this.outerCircle - this.innerCircle) / 2) * 0.9;
      const x = Math.cos(a) * center;
      const y = Math.sin(a) * center;
      const n = (10 - i) % 10;
      this.c.beginPath();
      this.c.arc(x, y, this.size * 0.08, 0, this.TWOPI);

      let gradientFill = this.c.createRadialGradient(
        x,
        y,
        this.size * 0.06,
        x,
        y,
        this.size * 0.08
      );
      gradientFill.addColorStop(0, "#3f3f3f");
      gradientFill.addColorStop(1, "#000");

      this.c.fillStyle = gradientFill || this.circlesFillColor;
      this.c.strokeStyle = this.circlesStrokeColor;
      if (
        this.state.clickedNumber === n ||
        (this.state.number !== null && this.state.number % 10 === n)
      ) {
        let gradientFill = this.c.createRadialGradient(
          x,
          y,
          this.size * 0.04,
          x,
          y,
          this.size * 0.09
        );
        gradientFill.addColorStop(0, this.circlesHighlightFillColor);
        gradientFill.addColorStop(1, "#000");
        this.c.fillStyle = gradientFill;

        this.c.strokeStyle = this.circlesHighlightStrokeColor;
      }
      this.c.fill();
      this.c.stroke();
      this.c.fillStyle = this.textFillColor;
      this.c.strokeStyle = this.textStrokeColor;
      if ( this.state.clickedNumber === n ||(this.state.number !== null && this.state.number % 10 === n)) {
        this.c.fillStyle = this.circlesHighlightTextColor;
      }
      this.c.fillText(n, x, y + this.size * 0.02);
      this.c.strokeText(n, x, y + this.size * 0.02);
    }

    this.c.restore();
  }

  addEvent() {
    this.canvas.addEventListener("mousedown", (e) => {
      this.isClicking(e);
    });

    this.canvas.addEventListener("mouseup", (e) => {
      this.result(e);
    });

    this.canvas.addEventListener("mouseout", (_) => {
      this.clear();
    });

    this.canvas.addEventListener("mousemove", (e) => {
      this.rotate(e);
    });

    this.canvas.addEventListener("touchstart", (e) => {
      this.isClicking(e);
    });

    this.canvas.addEventListener("touchmove", (e) => {
      this.rotate(e);
    });

    this.canvas.addEventListener("touchend", (e) => {
      this.result(e);
    });
  }

  result(e) {
    if (this.state.number) {
      let number = this.state.number;
      let returnAudio = document.getElementById("ret" + (number % 10));
      let duration = returnAudio.duration;
      let returnSpeed = (number * 0.5 + 0.5) / (duration * 60);
      this.setState({ returnSpeed });
      number = number % 10;
      returnAudio.play();
      this.props.callback(number);
    } else {
      this.clickHandler(e); // Handle the click logic here
    }

    this.clear();
  }

  isClicking(e) {
    e.preventDefault();
    const pos = this.getPos(e);
    const dist = this.getDist(pos.x, pos.y, this.w2, this.h2);
    if (dist > this.size / 2 || dist < this.size / 2 - this.offset) return;

    let lastAngle = Math.atan2(pos.y - this.h2, pos.x - this.w2);
    let angle = -Math.atan2(pos.y - this.h2, pos.x - this.w2);
    angle = angle > 0 ? angle : angle + this.TWOPI;
    let n = Math.floor((angle - 0.5) / 0.5) + 1;

    this.setState({
      lastAngle,
      number: null,
      clicking: true,
      initialNumber: n,
      initialPosition: { x: pos.x, y: pos.y },
    });
  }

  clickHandler(e) {
    e.preventDefault();
    const pos = this.getPos(e);
    const dist = this.getDist(
      pos.x,
      pos.y,
      this.state.initialPosition.x,
      this.state.initialPosition.y
    );
    if (dist > 0) return;
    let angle = -Math.atan2(pos.y - this.h2, pos.x - this.w2);
    angle = angle > 0 ? angle : angle + this.TWOPI;
    let number = Math.floor((angle - 0.5) / 0.5) + 1;
    number = number % 10;
    this.setState({ clickedNumber: number });
    setTimeout(() => {
      this.setState({ clickedNumber: null });
    }, 150);
    this.props.callback(number);
  }

  getDist(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
  }

  getPos(e) {
    e.preventDefault();
    let x, y;
    const rect = this.canvas.getBoundingClientRect();
    const _x = this.canvas.width / rect.width;
    const _y = this.canvas.height / rect.height;
    if (e.touches && e.touches.length > 0) {
      x = (e.targetTouches[0].pageX - rect.left) * _x;
      y = (e.targetTouches[0].pageY - rect.top) * _y;
    } else if (e.changedTouches && e.changedTouches.length > 0) {
      x = (e.changedTouches[0].pageX - rect.left) * _x;
      y = (e.changedTouches[0].pageY - rect.top) * _y;
    } else {
      x = e.offsetX * _x;
      y = e.offsetY * _y;
    }
    return { x, y };
  }

  clear() {
    this.setState({ number: null, initialNumber: null, clicking: false });
    this.goBack();
  }

  rotate(e) {
    if (!this.state.clicking || this.state.a >= this.TWOPI) return;
    if (this.state.a < 1) {
      this.setState({ a: 1 });
      return;
    }
    const pos = this.getPos(e);
    const n = Math.floor(((this.state.a - 0.7) / (this.TWOPI - 0.8)) * 11);
    if (n > this.state.initialNumber) {
      return;
    }
    let number = n > 0 ? n : null;
    let newAngle = Math.atan2(pos.y - this.h2, pos.x - this.w2);

    const delta = this.state.a - (this.state.lastAngle - newAngle);
    let a = delta > 0 ? delta : this.TWOPI + delta;
    this.setState({ number, newAngle, a, lastAngle: newAngle });
    this.draw();
  }

  goBack() {
    let a;
    if (this.state.a > 1) {
      a = this.state.a - (this.state.returnSpeed || 0.05);
      this.draw();
      requestAnimationFrame((_) => {
        this.goBack();
      });
      if (this.state.a - 1 < 0.05) a = 1;
      this.setState({ a });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.firstRenderTimeout);
  }

  render() {
    return (
      <div
        style={{
          ...this.props.style,
          width: this.props.canvasSize + "px",
          height: this.props.canvasSize + "px",
        }}
      >
        <canvas
          width={this.props.canvasSize}
          height={this.props.canvasSize}
          ref={this.canvasRef}
          style={{ borderRadius: "50%" }}
        />
        {[...Array(10).keys()].map((key) => {
          return (
            <audio
              controls
              key={"ret" + key}
              id={"ret" + key}
              hidden
              crossOrigin="anonymous"
            >
              <source src={rotateSFXs[key]} type="audio/mpeg" />
            </audio>
          );
        })}
      </div>
    );
  }
}

export default DialpadRenderer;
